import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { VertSearch } from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';

import 'Assets/styles/default/components/Search/autocomplete.less';

import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import { stringToSlug } from 'Utils/stringToSlug';
import generateUUID from 'Utils/generateUUID';
import SearchAutocomplete from './SearchAutocomplete';
import CreateSearchHash from 'Utils/createSearchHash';
import { useNavigate } from 'react-router';

const SearchContainer = ({ openCloseSearchHandler }) => {
  const [query, setQuery] = useState('');
  const [term, setTerm] = useState('');
  const [results, setResults] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [isOpen, setIsOpen] = useState(false);
  const [timer, setTimer] = useState(null);
  const inputRef = useRef(null);

  const { callApi } = usePipeContext();
  const navigate = useNavigate();

  const Autocomplete = useSelector(({ Autocomplete: data }) => data);
  /* eslint-disable */
  const handleAutocomplete = (term, alias = null) => {
    callApi({
      symbol: 'FETCH_AUTOCOMPLETE',
      alias: alias || stringToSlug(term),
      payload: {
        term,
      },
    });
  };

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setQuery(inputValue);
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      const aliasUUID = generateUUID(); // Gerar o alias apenas quando o usuário terminar de digitar
      setTerm(inputValue);
      handleAutocomplete(inputValue, aliasUUID);
    }, 500);

    setTimer(newTimer);
  };

  const handleHistory = (term) => {
    if ((term && term !== '') || (query && query !== '')) {
      const storedValues =
        JSON.parse(localStorage.getItem('searchValues')) || [];
      const index = storedValues.indexOf(term || query);

      if (index !== -1) {
        storedValues.splice(index, 1);
      }
      storedValues.unshift(query);
      const maxStoredValues = 5;
      if (storedValues.length > maxStoredValues) {
        storedValues.pop();
      }
      localStorage.setItem('searchValues', JSON.stringify(storedValues));
    }
  };

  const combineResultsWithHistory = () => {
    const searchValues = JSON.parse(localStorage.getItem('searchValues')) || [];
    const allTerms = {
      historyTerms: searchValues,
      results,
      term,
    };
    return allTerms;
  };

  const handleButtonHandler = () => {
    handleHistory();
    navigate(`/search/1/filter/${CreateSearchHash({}, { term: query })}`);
    handleResetStates();
  };

  const selectResult = (key) => {
    if (selectedIndex >= 0 && selectedIndex < results.length) {
      const selectedResult = results[selectedIndex];
      handleHistory(selectedResult.name);
    }
    if (key === 'Enter') {
      handleButtonHandler();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      setSelectedIndex((prevIndex) =>
        Math.min(prevIndex + 1, results.length - 1)
      );
    } else if (event.key === 'Enter') {
      event.preventDefault();
      selectResult(event.key);
    }
  };

  const handleBlur = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const results =
      (Autocomplete &&
        Autocomplete?.autocomplete &&
        Autocomplete?.autocomplete.categories) ||
      [];
    setResults(results);
    setIsOpen(results.length > 0);
  }, [Autocomplete?.autocomplete]);

  const handleResetStates = () => {
    setIsOpen(false);
    setQuery('');
    setSelectedIndex(-1);
    openCloseSearchHandler();
  };

  return (
    <div className="vtex-color-fix-vetmax">
      <VertSearch
        type="text"
        placeholder="Digite sua busca"
        value={query}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        onButtonHandler={handleButtonHandler}
        ref={inputRef}
      />
      {isOpen && (
        <SearchAutocomplete
          selectedIndex={selectedIndex}
          onClick={handleResetStates}
          {...combineResultsWithHistory()}
        />
      )}
    </div>
  );
};

SearchContainer.propTypes = {
  openCloseSearchHandler: PropTypes.func.isRequired,
};

export default SearchContainer;
